import React from 'react';
import { Lightbulb, Target, ChevronRight } from 'lucide-react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};

const item = {
  hidden: { opacity: 0, x: -20 },
  show: { opacity: 1, x: 0 }
};

export function JournalAnalysis({ analysis }) {
  const { t } = useTranslation();

  if (!analysis) return null;

  return (
    <motion.div
      variants={container}
      initial="hidden"
      animate="show"
      className="space-y-4"
    >
      {/* Observaciones */}
      <motion.div
        variants={item}
        className="bg-gradient-to-r from-amber-50 to-yellow-50 dark:from-amber-900/20 dark:to-yellow-900/20 
          rounded-xl p-4 border border-amber-100 dark:border-amber-800/30"
      >
        <div className="flex items-start space-x-3">
          <div className="p-2 bg-white dark:bg-gray-800 rounded-lg shadow-sm">
            <Lightbulb className="w-5 h-5 text-yellow-500 dark:text-yellow-400" />
          </div>
          <div className="flex-1">
            <h4 className="font-medium text-gray-900 dark:text-white flex items-center">
              {t('journal.analysis.observations')}
            </h4>
            <p className="text-gray-600 dark:text-gray-300 mt-2 leading-relaxed">
              {analysis.observations}
            </p>
          </div>
        </div>
      </motion.div>

      {/* Sugerencias */}
      <motion.div
        variants={item}
        className="bg-gradient-to-r from-emerald-50 to-green-50 dark:from-emerald-900/20 dark:to-green-900/20 
          rounded-xl p-4 border border-emerald-100 dark:border-emerald-800/30"
      >
        <div className="flex items-start space-x-3">
          <div className="p-2 bg-white dark:bg-gray-800 rounded-lg shadow-sm">
            <Target className="w-5 h-5 text-emerald-500 dark:text-emerald-400" />
          </div>
          <div className="flex-1">
            <h4 className="font-medium text-gray-900 dark:text-white">
              {t('journal.analysis.tomorrowSuggestions')}
            </h4>
            <ul className="mt-2 space-y-2">
              {analysis?.tomorrowSuggestions?.map((suggestion, index) => (
                <motion.li
                  key={index}
                  initial={{ opacity: 0, x: -10 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: index * 0.1 }}
                  className="flex items-start space-x-2 bg-white/60 dark:bg-gray-800/60 p-3 rounded-lg backdrop-blur-sm"
                >
                  <ChevronRight className="w-4 h-4 text-emerald-500 dark:text-emerald-400 flex-shrink-0 mt-0.5" />
                  <span className="text-gray-700 dark:text-gray-300">
                    {suggestion}
                  </span>
                </motion.li>
              ))}
            </ul>
          </div>
        </div>
      </motion.div>
    </motion.div>
  );
}

export default JournalAnalysis;